import { createCn } from 'shared-utils'

export const summaryBoxesButtonCn = createCn('summary-boxes')
